import { render, staticRenderFns } from "./ProductGroupDialogContent.vue?vue&type=template&id=0838dce1&scoped=true"
import script from "./ProductGroupDialogContent.vue?vue&type=script&lang=js"
export * from "./ProductGroupDialogContent.vue?vue&type=script&lang=js"
import style0 from "./ProductGroupDialogContent.vue?vue&type=style&index=0&id=0838dce1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0838dce1",
  null
  
)

export default component.exports